import React from 'react'
import { 
    Card, 
    CardContent, 
    Typography, 
} from '@material-ui/core'
import { formatPlainDateDisplay } from '../../utils/DateUtils'

const UpcomingBayphones = (props) => {
    const { index, upcoming, t } = props

    const formattedUpcomingDate = formatPlainDateDisplay(upcoming?.validSince)

    return (
        <>
            <Card key={"avaiables"+index} component="form" noValidate style={{ marginBottom: 10, width: '100%' }}>
                <CardContent style={{ padding: 10 }}>
                    <Typography variant="subtitle1"><b>{t('Device Type')}: </b>{upcoming.deviceType.name}</Typography>
                    <div style={{ display: 'flex' }}>
                        <Typography style={{ marginTop: 10, marginRight: 10, width: 200 }} variant="body2"><b>{t('Date')}: </b>{formattedUpcomingDate}</Typography>
                    </div>
                </CardContent>
            </Card>
        </>
    )
}

export default UpcomingBayphones